import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {DashboardSummaryModel} from '../models/dashboard-summary.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private readonly apiUrl = `${environment.apiUrl}/api/dashboard`;

  constructor(private http: HttpClient) {}

  getSummary(): Observable<DashboardSummaryModel> {
    return this.http.get<DashboardSummaryModel>(`${this.apiUrl}/summary`);
  }
}

